module.exports = angular.module('cartographer.common.number', [])

_ = require 'underscore'

module.exports.factory 'crtNumber', $DI (crtLog) ->
  isInteger = (num) ->
    if typeof num == "number"
      if isNaN(num)
        false
      else
        num == Math.round(num)
    else
      false

  return {
    isInteger
  }

module.exports.filter 'floor', $DI (crtLog) ->
  (value) ->
    Math.floor(value)
